import {
  CHANGE_ACTIVE_SIDEBAR_ITEM,
  CLOSE_SIDEBAR,
  OPEN_SIDEBAR,
} from "../constants/navigationConstants";

export function openSidebar() {
  return {
    type: OPEN_SIDEBAR,
  };
}

export function closeSidebar() {
  return {
    type: CLOSE_SIDEBAR,
  };
}

export function changeActiveSidebarItem(activeItem) {
  return {
    type: CHANGE_ACTIVE_SIDEBAR_ITEM,
    activeItem,
  };
}
